// Плашка «Доступна новая версия» внизу экрана (на телефоне — над нижней навигацией)
import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppUpdate } from '../hooks/useAppUpdate';
import { MOBILE_NAV_HEIGHT } from './layout/AppLayout';

const ACCENT = '#ff7043';

export default function UpdateBanner({ aboveMobileNav = false }) {
  const { updateAvailable, dismiss } = useAppUpdate();
  if (!updateAvailable) return null;

  const mobileBottom = aboveMobileNav
    ? `calc(${MOBILE_NAV_HEIGHT}px + 12px + env(safe-area-inset-bottom, 0px))`
    : 'calc(16px + env(safe-area-inset-bottom, 0px))';

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        left: { xs: 16, md: '50%' },
        right: { xs: 16, md: 'auto' },
        bottom: { xs: mobileBottom, md: 24 },
        transform: { md: 'translateX(-50%)' },
        width: { md: 'auto' },
        maxWidth: { md: 480 },
        zIndex: 1100, // над нижней навигацией, под диалогами
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        pl: 2,
        pr: 0.5,
        py: 0.75,
        boxSizing: 'border-box',
        backgroundColor: '#202024',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '12px',
        boxShadow: '0 12px 32px rgba(0,0,0,0.45)',
      }}
    >
      <Typography sx={{ flex: 1, minWidth: 0, fontSize: '14px', color: '#e4e4e7', whiteSpace: { md: 'nowrap' } }}>
        Доступна новая версия
      </Typography>
      <Button
        onClick={() => window.location.reload()}
        sx={{
          flexShrink: 0,
          height: 36,
          px: 2,
          borderRadius: '10px',
          textTransform: 'none',
          fontWeight: 700,
          color: '#1a0f0a',
          backgroundColor: ACCENT,
          boxShadow: 'none',
          '&:hover': { backgroundColor: '#ff8a65', boxShadow: 'none' },
        }}
      >
        Обновить
      </Button>
      <IconButton aria-label="Закрыть" onClick={dismiss} sx={{ flexShrink: 0, width: 44, height: 44, color: '#a1a1aa' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
